import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { BookOpen, Compass, HelpCircle, Sparkles, Printer } from "lucide-react";

/**
 * Consejos y comentarios generales de auditoría ISO 56001 (contenido estático desde
 * imagen del usuario). Aparece como pestaña permanente en /auren.
 */
export function AurenConsejosTab() {
  return (
    <div className="space-y-4 print:space-y-2" data-testid="auren-consejos-tab" id="auren-consejos-printable">
      <div className="flex justify-end print:hidden">
        <Button size="sm" variant="outline" onClick={() => window.print()} data-testid="auren-consejos-print">
          <Printer className="w-3.5 h-3.5 mr-1" />Imprimir / PDF
        </Button>
      </div>

      <div className="hidden print:block mb-4">
        <h1 className="text-xl font-bold">Consejos ISO 56001 · Auditoría</h1>
        <p className="text-xs text-slate-600">Checklist previa al día de la auditoría · Innovation OS Valoriza</p>
      </div>
      <Card>
        <CardContent className="p-5 space-y-4">
          <div className="flex items-start gap-3">
            <Compass className="w-5 h-5 text-emerald-600 mt-1 flex-shrink-0" />
            <div>
              <h3 className="font-bold text-base mb-1">Alcance de la auditoría</h3>
              <ul className="text-sm text-slate-700 dark:text-slate-300 space-y-1.5 list-disc pl-4">
                <li>Fijado previamente a la auditoría; tiene en cuenta los proyectos de los <strong>últimos 6 años</strong> — no solo del último año.</li>
                <li>Va acorde con las líneas establecidas en la ficha con AENOR. Cada año deben revisarse líneas que <strong>no se hayan revisado antes</strong>, sin repetir.</li>
                <li>Se revisa y modifica, si es necesario, antes de cada auditoría — pueden añadirse nuevas líneas/áreas por proyectos de nueva índole.</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-5 space-y-2">
          <div className="flex items-start gap-3">
            <Sparkles className="w-5 h-5 text-amber-600 mt-1 flex-shrink-0" />
            <div>
              <h3 className="font-bold text-base mb-1">DAFO</h3>
              <p className="text-sm text-slate-700 dark:text-slate-300">
                Hay que utilizarlo para detectar las <strong>oportunidades más estratégicas</strong>. Las ayudas son muy bajas.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-5">
          <div className="flex items-start gap-3">
            <HelpCircle className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
            <div className="flex-1">
              <h3 className="font-bold text-base mb-2">Proyectos · Temas que pregunta el auditor</h3>
              <ul className="text-sm text-slate-700 dark:text-slate-300 grid md:grid-cols-2 gap-x-6 gap-y-1.5 list-disc pl-4">
                <li>Por qué ese proyecto es Innovación</li>
                <li>Detalle de la solución</li>
                <li>Socios / colaboradores</li>
                <li>Memoria y paquetes de trabajo</li>
                <li>Firmas de partes de hora del personal</li>
                <li>Estructura de la carpeta</li>
                <li>Riesgos generales y técnicos específicos del proyecto</li>
                <li>Actualización trimestral en Airtable (enseñar la ficha descargada en PDF)</li>
                <li>Contrato de socios / colaboradores</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-5">
          <div className="flex items-start gap-3">
            <BookOpen className="w-5 h-5 text-violet-600 mt-1 flex-shrink-0" />
            <div className="flex-1">
              <h3 className="font-bold text-base mb-1">Proyectos sin financiación</h3>
              <p className="text-sm text-slate-700 dark:text-slate-300 mb-2">
                Se pueden incluir también en el grueso de proyectos presentados. No tienen que tener tanta información como los subvencionados pero pueden seguir la <strong>misma estructura de carpetas</strong> e incluir, por ejemplo:
              </p>
              <ul className="text-sm text-slate-700 dark:text-slate-300 grid md:grid-cols-2 gap-x-6 gap-y-1 list-disc pl-4">
                <li>Memoria sencilla</li>
                <li>Novedad tecnológica</li>
                <li>Estado del arte</li>
                <li>Cronograma</li>
                <li>Candidato a tener IMV (Informe Motivado Vinculante)</li>
                <li>Gastos incurridos</li>
                <li>Avances</li>
                <li>Sistemática de aprobación</li>
                <li>Aplicación a negocio / la empresa</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
